import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Custom hook to handle navigation prompts for both browser back/forward and page close/refresh
 * @param {boolean} isDirty - Whether there are unsaved changes
 * @param {string} message - The message to show in the confirmation dialog
 */
const useNavigationPrompt = (isDirty, message = "Are you sure you want to leave this page?") => {
    const location = useLocation();

    useEffect(() => {
        function onPopState(event) {
            if (isDirty) {
                const confirmed = window.confirm(message);
                if (confirmed) {
                    return;
                } else {
                    event.preventDefault();
                    window.history.pushState(null, '', location.pathname);
                }
            }
        }

        function onBeforeUnload(event) {
            if (isDirty) {
                event.preventDefault();
                event.returnValue = '';
                return '';
            }
        }

        window.addEventListener('popstate', onPopState);
        window.addEventListener('beforeunload', onBeforeUnload);

        return () => {
            setTimeout(() => {
                window.removeEventListener('popstate', onPopState);
            }, 0);
            window.removeEventListener('beforeunload', onBeforeUnload);
        };
    }, [isDirty, message]);
};

export default useNavigationPrompt; 